export default "__VITE_ASSET__Cz27bh$A__"